<template>
	<article :class="`w-100 bg-body tooldialog flex-column ${expanded ? 'expanded' : '' }`" :style="wrapperStyle">
		<!--this component's active property is intended to define when it becomes manipulatable, but clicking on the component always makes it active, so we use resizable for this purpose instead, setting active and prevent-deactivation to true so the component is active unless we turn off resizable-->
		<div
			:resizable="resizable"
			:active="true"
			:prevent-deactivation="true"
			:w="wide ? 656 : 328"
			:h="height"
			:class="{'not-resizable': !resizable, 'not-theoretically-resizable': !theoreticallyResizable}"		
			@resizing="onResize"
		>
			<header class="d-flex bg-primary align-items-center">
				<i v-if="icon.length" class="text-white pl-2" :class="'tan-icon-'+icon" />
				<span class="w-100 text-white pl-2 text-bold">{{ displayName }}</span>
				<button
					v-if="expandable"
					class="btn btn-sm btn-secondary text-primary px-2 shadow-none"
					@click="$emit('expand')"
				>
					<i :class="expanded ? 'tan-icon-arrow-up' : 'tan-icon-arrow-down'" />
				</button>
				<button
					class="btn btn-sm btn-secondary text-primary px-2 shadow-none"
					@click="$emit('remove')"
				>
					<i class="tan-icon-close-window" />
				</button>
			</header>

			<div class="search-container">
				<search-bar v-if="searchable" v-model="query" name="query" />
				<b-dropdown v-if="filterable">
					<template #button-content>
						<i class="tan-icon-measure" />
					</template>
					<b-dropdown-form>
						<b-form-checkbox :checked="allFilterItemsAreVisible" @change="$emit('show-hide-all')">
							Show/Hide All
						</b-form-checkbox>
						<b-form-checkbox
							v-for="item in filterItems"
							:key="item.name"
							:checked="item.visible"
							@change="$emit('filter-change', item.name)"
						>
							{{ item.name }}
						</b-form-checkbox>
					</b-dropdown-form>
				</b-dropdown>
			</div>

			<main :class="`flex-grow-1 ${expanded ? 'expanded-main' : ''} ${!searchable ? 'no-search' : ''}`" :style="{height: !expanded ? maxHeight : null }">
				<slot />
			</main>

			<footer>
				<slot name="footer" />
			</footer>
		</div>
	</article>
</template>

<script>
import BaseTool from '@/components/Project/Tool/BaseTool.vue';

export default {
	name: 'ToolDialog',
	extends: BaseTool,
	props: {
		displayName: {
			type: String,
			required: true,
		},
		wide: {
			type: Boolean,
			defaul: false,
		},
		searchable: {
			type: Boolean,
			required: true,
		},
		expandable: {
			type: Boolean,
			required: false,
		},
		maxHeight: {
			type: String,
			default: null,
		},
		filterable: {
			type: Boolean,
			default: false,
		},
		filterItems: {
			type: Array,
			default() {
				return [];
			},
		},
		icon: {
			default: '',
			type: String,
		},
	},
	data() {
		return {
			query: '',
			unexpandedHeight: 100,
		};
	},
	computed: {
		allFilterItemsAreVisible() {
			return this.filterItems.every((item) => item.visible);
		},
		displayHeight() {
			if (!this.theoreticallyResizable) return 'auto';
			return this.expanded ? 'calc(100vh - 45px)' : `${this.height + 9}px`;
		},
		height() {
			return !this.theoreticallyResizable || this.expanded ? 'auto' : this.unexpandedHeight;
		},
		resizable() {
			return this.theoreticallyResizable && this.currentlyResizable && !this.expanded;
		},
		wrapperStyle() {
			return {
				'--display-height': this.displayHeight,
				height: 'var(--display-height)',
			};
		},
	},
	watch: {
		query(val) {
			this.$parent.query = val;
		},
	},
	methods: {
		onResize(_x, _y, _width, height) {
			this.unexpandedHeight = height;
		},
	},
};
</script>

<style lang="scss" scoped>
.tooldialog {
	overflow-x: hidden;
	display: flex;

	& .expanded {
		height: calc(100vh - 45px);
	}

	& header {
		span {
			line-height: 2em;
		}
		button.btn {
			height: 2rem;
			font-size: 0.7em;
		}
	}

	& .search-container {
		display: flex;
	}

	& main {
		max-height: calc(100vh - 7.7em);
		overflow-y: auto;
		overflow-x: hidden;
	}

	& main.no-search {
		max-height: calc(100vh - 4.9em);
	}
}
</style>

<style>
.vdr {
	border-top: none;
	border-right: none;
	border-left: none;
	height: var(--display-height) !important;
	overflow: hidden;
}

.not-resizable {
	border: none;
}

.not-theoretically-resizable {
	position: static;
}

.handle {
	bottom: 0;
}
</style>
